import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import type { Quote } from '../../types';

interface QuoteDiscardDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  quote: Quote | null;
  onConfirm: () => void;
  isLoading?: boolean;
}

export function QuoteDiscardDialog({
  open,
  onOpenChange,
  quote,
  onConfirm,
  isLoading,
}: QuoteDiscardDialogProps) {
  const { t } = useTranslation('quotes');

  if (!quote) return null;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('discard.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('discard.message')}
            <br />
            <strong>{t('discard.quoteLabel')}</strong> #{quote.quoteNumber}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>{t('discard.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
          >
            {t('discard.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
